export default __webpack_public_path__ + "static/media/pink-4.b17365b8.png";